export default __webpack_public_path__ + "a8584320cb0dabebae28b96719899fc5.svg";